<template>
  <footer ref="footer">
    <div class="container">
      <div class="row footer__row">
        <div class="col-lg-3 col-md-3">
          <a href="https://www.tn.ru/" target="_blank" class="footer__logo">
            <img src="@/assets/img/logo.svg" alt="logo">
          </a>
        </div>
        <div class="col-lg-4 col-md-5">
          <a href="https://shop.tn.ru/teploizoljacija"
             onclick="dataLayer.push({'event': 'calc-roofload-wherebuy'})"
             target="_blank"
             class="footer__link">Где купить?</a>
          <a href="https://nav.tn.ru/services/proektno-raschetnyy-tsentr/form/"
             onclick="dataLayer.push({'event': 'calc-roofload-prc'})"
             target="_blank" class="footer__link">
            Заказать профессиональный расчет в ПРЦ
          </a>
          <a href="https://nav.tn.ru/services/support/" target="_blank" class="footer__link">
            Задать вопрос эксперту
          </a>
        </div>
        <div class="col-lg-3 offset-lg-2 col-md-4">
          <div class="footer__btns">
            <a href="https://nav.tn.ru/message/" class="footer__error" target="_blank">
              <img src="@/assets/img/alert.svg" alt="!">
              <span>Нашли <br>ошибку?</span>
            </a>
            <a href="https://nav.tn.ru/calculators/embed/" class="footer__code" target="_blank">
              <img src="@/assets/img/coder.svg" alt="<>">
              <span>Код <br>на сайт</span>
            </a>
          </div>
          <a href="http://industrialmedia.com.ua/" target="_blank" class="footer__madeBy">
            <img src="@/assets/img/logo-im.svg" alt="IndistrialMedia">
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
  },
};
</script>

<style lang="sass" scoped>
  footer
    background: #F6F6F6
    border: rem(1) solid #ECECEC
    box-sizing: border-box
    +media((padding: (320: rem(32) rem(24), 768: rem(40) 0)))
    .container
      +media((padding: (320: 0, 768: 0 rem(15), 992: 0)))
    .footer
      &__logo
        display: block
        +media((margin-bottom: (320: rem(30), 768: 0)))
        img
          margin: 0
          float: left
      &__link
        font-style: normal
        font-weight: 500
        font-size: rem(12)
        line-height: rem(20)
        color: $red
        text-decoration: none
        cursor: pointer
        display: block
        text-align: left
        +media((margin-bottom: (320: rem(12), 768: rem(14))))
        &:first-of-type
          +media((padding-top: (320: rem(30), 768: 0)))
      &__btns
        display: flex
        flex-direction: row
        align-items: center
        +media((padding-top: (320: rem(11), 768: 0)))
      &__error
        padding-right: rem(20)
      &__error, &__code
        display: flex
        flex-direction: row
        align-items: center
        cursor: pointer
        text-decoration: none
        img
          padding-right: rem(11)
        span
          font-style: normal
          font-weight: 500
          font-size: rem(12)
          line-height: rem(15)
          color: #999999
          text-align: left
      &__madeBy
        display: block
        +media((margin-top: (320: rem(34), 768: rem(40))))
        img
          margin: 0
          float: left
</style>
